// extracted by mini-css-extract-plugin
module.exports = {"b5bt6fr":"b5bt6fr"};